import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import HeaderDropdown from './HeaderDropdown';
import { Dialogue } from '../section-components/Dialogue';
import SignInPage from '../sign-in';
import SignUpPage from '../sign-up';
import { IconButton } from '@mui/material';
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import "../../assets/css/navbar.css";
import LogoImg from '../../assets/img/LogoImg' // Mobile logo import
import CustomSVG from '../../assets/img/customizeSVG'; // Large screen logo import

const Navbar = () => {
    const [isMenuOpen, setMenuOpen] = useState(false);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [open, setOpen] = React.useState(false);
    const [openRegister, setOpenRegister] = React.useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleMenu = () => {
        const newMenuState = !isMenuOpen;
        setMenuOpen(newMenuState);
        setActiveDropdown(null); // Close all dropdowns when toggling main menu

        // Prevent body scroll when mobile menu is open
        if (newMenuState) {
            // Store current scroll position
            const scrollY = window.scrollY;
            document.body.classList.add('menu-open');
            document.documentElement.classList.add('menu-open');
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
        } else {
            // Restore scroll position
            const scrollY = document.body.style.top;
            document.body.classList.remove('menu-open');
            document.documentElement.classList.remove('menu-open');
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }
    };

    const closeMenu = () => {
        setMenuOpen(false);
        setActiveDropdown(null);

        // Restore scroll position
        const scrollY = document.body.style.top;
        document.body.classList.remove('menu-open');
        document.documentElement.classList.remove('menu-open');
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
    };

    const toggleDropdown = (dropdownName, e) => {
        e.preventDefault();
        e.stopPropagation();
        if (windowWidth <= 991) {
            const newActiveDropdown = activeDropdown === dropdownName ? null : dropdownName;
            console.log('Toggling dropdown:', dropdownName, 'New state:', newActiveDropdown); // Debug log
            setActiveDropdown(newActiveDropdown);
        }
    };

    // Close menu when clicking outside or on menu items
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isMenuOpen && windowWidth <= 991) {
                const navbar = document.querySelector('.navbar-collapse');
                if (navbar && !navbar.contains(event.target) && !event.target.closest('.toggle-btn')) {
                    closeMenu();
                }
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            // Cleanup on unmount - restore scroll
            document.body.classList.remove('menu-open');
            document.documentElement.classList.remove('menu-open');
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
        };
    }, [isMenuOpen, windowWidth]);

    let user = JSON.parse(sessionStorage.getItem('user'));
    const [users] = useState(user);

    return (
        <div className="navbar-area navbar-area-1">
            {/* <div className="navbar-top">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 col-md-8 col-sm-12 registerMob">
                            <ul>
                                <li>
                                    <p>
                                        <img src={`${publicUrl}assets/img/icon/phone.png`} alt="phone icon" style={{ width: '20px', marginRight: '8px', filter: 'brightness(0) saturate(100%) invert(62%) sepia(98%) saturate(749%) hue-rotate(1deg) brightness(97%) contrast(101%)' }} />
                                        <a href="tel:7893092211" style={{ textDecoration: 'none', color: '#000' }}>+91 78930 92211</a>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <img src={`${publicUrl}assets/img/icon/phone.png`} alt="phone icon" style={{ width: '20px', marginRight: '8px', filter: 'brightness(0) saturate(100%) invert(62%) sepia(98%) saturate(749%) hue-rotate(1deg) brightness(97%) contrast(101%)' }} />
                                        <a href="tel:9988776655" style={{ textDecoration: 'none', color: '#000' }}>+91 99887 76655</a>
                                    </p>
                                </li>
                                <li>
                                    <p>
                                        <img src={`${publicUrl}assets/img/icon/envelope.png`} alt="email icon" style={{ width: '20px', marginRight: '8px', filter: 'brightness(0) saturate(100%) invert(62%) sepia(98%) saturate(749%) hue-rotate(1deg) brightness(97%) contrast(101%)' }} />
                                        <a href="mailto:info@royalespaces.com" style={{ textDecoration: 'none', color: '#000' }}>info@royalespaces.com</a>
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-12 d-flex justify-content-center justify-content-md-end">
                            <ul className="topbar-right text-lg-right text-end">
                                {!users ? (
                                    <li>
                                        <Link className="ml-0" to="" onClick={() => setOpenRegister(true)}>Register</Link>
                                        <Link to="" onClick={() => setOpen(true)}>Login</Link>
                                    </li>
                                ) : (
                                    <li>
                                        <p>Welcome, {users.name || "User"}!</p>
                                    </li>
                                )}
                                <li className="social-area">
                                    <a href="https://www.facebook.com/profile.php?id=61571816318492" aria-label="Facebook"><i className="fab fa-facebook-f" aria-hidden="true" /></a>
                                    <a className="twitter-link" href="https://x.com/RoyaleSpaces" aria-label="Twitter"><FaXTwitter /></a>
                                    <a href="https://www.instagram.com/royalespaces/" aria-label="Instagram"><i className="fab fa-instagram" aria-hidden="true" /></a>
                                    <a href="https://www.youtube.com/@RoyaleSpaces" aria-label="YouTube"><i className="fab fa-youtube" aria-hidden="true" /></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div> */}

            <nav className="navbar navbar-expand-lg">
                <div className="nav-container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <div className="responsive-mobile-menu">
                        <button
                            className={`menu toggle-btn d-block d-lg-none ${isMenuOpen ? 'open' : ''}`}
                            onClick={toggleMenu}
                            aria-expanded={isMenuOpen}
                            aria-label="Toggle navigation"
                        >
                            <span className="icon-left" />
                            <span className="icon-right" />
                        </button>
                    </div>

                    <div className="logo">
                        <Link to="/" onClick={closeMenu}>
                            {windowWidth <= 475 ? <LogoImg className="mobile-logo" /> : <CustomSVG className="desktop-logo" />}
                        </Link>
                    </div>

                    <div className={`collapse navbar-collapse ${isMenuOpen ? 'show' : ''}`} id="dkt_main_menu">
                        {/* Close button for mobile */}
                        {isMenuOpen && windowWidth <= 991 && (
                            <button
                                className="mobile-close-btn"
                                onClick={closeMenu}
                                style={{
                                    position: 'absolute',
                                    top: '20px',
                                    right: '30px',
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '30px',
                                    color: '#fff',
                                    cursor: 'pointer',
                                    zIndex: 10000,
                                    lineHeight: 1,
                                    fontWeight: 300,
                                    padding: '5px',
                                    borderRadius: '50%',
                                    width: '40px',
                                    height: '40px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                                    e.target.style.transform = 'rotate(90deg)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.backgroundColor = 'transparent';
                                    e.target.style.transform = 'rotate(0deg)';
                                }}
                            >
                                ×
                            </button>
                        )}

                        <ul className="navbar-nav menu-open text-end px-4">
                            <li className="menu-item-has-children current-menu-item">
                                <Link to="/" onClick={closeMenu}>Home</Link>
                            </li>
                            <li className={`menu-item-has-children current-menu-item ${activeDropdown === 'sales' ? 'dropdown-active' : ''}`}>
                                <Link
                                    to="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (windowWidth <= 991) {
                                            toggleDropdown('sales', e);
                                        }
                                    }}
                                    className="dropdown-toggle"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        width: '100%'
                                    }}
                                >
                                    <span>Sales</span>
                                    {windowWidth <= 991 && (
                                        <span className={`dropdown-arrow ${activeDropdown === 'sales' ? 'active' : ''}`}>
                                            ▼
                                        </span>
                                    )}
                                </Link>
                                <ul
                                    className={`sub-menu ${activeDropdown === 'sales' ? 'show' : ''}`}
                                    style={{
                                        display: activeDropdown === 'sales' && windowWidth <= 991 ? 'block' : (windowWidth <= 991 ? 'none' : ''),
                                        maxHeight: activeDropdown === 'sales' && windowWidth <= 991 ? '300px' : (windowWidth <= 991 ? '0' : ''),
                                        opacity: activeDropdown === 'sales' && windowWidth <= 991 ? '1' : (windowWidth <= 991 ? '0' : ''),
                                        visibility: activeDropdown === 'sales' && windowWidth <= 991 ? 'visible' : (windowWidth <= 991 ? 'hidden' : ''),
                                        overflow: windowWidth <= 991 ? 'hidden' : '',
                                        transition: windowWidth <= 991 ? 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)' : ''
                                    }}
                                >
                                    <li><Link to="/commercial-plots-for-sale-in-amaravati" onClick={closeMenu}>Commercial</Link></li>
                                    <li><Link to="/residential-plots-for-sale-in-amaravati" onClick={closeMenu}>Residential</Link></li>
                                    <li><Link to="/agriculture-lands-for-sale-in-amaravati" onClick={closeMenu}>Agriculture lands</Link></li>
                                </ul>
                            </li>
                            <li className="menu-item-has-children current-menu-item">
                                <Link to="/about" onClick={closeMenu}>About us</Link>
                            </li>
                            <li className={`menu-item-has-children current-menu-item ${activeDropdown === 'blog' ? 'dropdown-active' : ''}`}>
                                <Link
                                    to="#"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        if (windowWidth <= 991) {
                                            toggleDropdown('blog', e);
                                        }
                                    }}
                                    className="dropdown-toggle"
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        width: '100%'
                                    }}
                                >
                                    <span>Blog</span>
                                    {windowWidth <= 991 && (
                                        <span className={`dropdown-arrow ${activeDropdown === 'blog' ? 'active' : ''}`}>
                                            ▼
                                        </span>
                                    )}
                                </Link>
                                <ul
                                    className={`sub-menu ${activeDropdown === 'blog' ? 'show' : ''}`}
                                    style={{
                                        display: activeDropdown === 'blog' && windowWidth <= 991 ? 'block' : (windowWidth <= 991 ? 'none' : ''),
                                        maxHeight: activeDropdown === 'blog' && windowWidth <= 991 ? '300px' : (windowWidth <= 991 ? '0' : ''),
                                        opacity: activeDropdown === 'blog' && windowWidth <= 991 ? '1' : (windowWidth <= 991 ? '0' : ''),
                                        visibility: activeDropdown === 'blog' && windowWidth <= 991 ? 'visible' : (windowWidth <= 991 ? 'hidden' : ''),
                                        overflow: windowWidth <= 991 ? 'hidden' : '',
                                        transition: windowWidth <= 991 ? 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)' : ''
                                    }}
                                >
                                    <li><Link to="/blog/amaravathi-news" onClick={closeMenu}>Amaravathi News</Link></li>
                                    <li><Link to="/blog/hyderabad-news" onClick={closeMenu}>Hyderabad News</Link></li>
                                </ul>
                            </li>
                            <li className="menu-item-has-children current-menu-item">
                                <Link to="/contact" onClick={closeMenu}>Contact Us</Link>
                            </li>
                            {users && (
                                <li className="menu-item-has-children current-menu-item">
                                    <Link to="/whishlist" onClick={closeMenu}>
                                        <IconButton>
                                            <FavoriteBorderIcon sx={{ color: "#fff" }} />
                                        </IconButton>
                                    </Link>
                                </li>
                            )}
                            {users && (
                                <li className="menu-item-has-children current-menu-item" onClick={closeMenu}>
                                    <HeaderDropdown />
                                </li>
                            )}
                        </ul>
                    </div>
                </div>
            </nav>

            {open && (
                <Dialogue open={open} onClose={setOpen}>
                    <SignInPage />
                </Dialogue>
            )}
            {openRegister && (
                <Dialogue open={openRegister} onClose={setOpenRegister}>
                    <SignUpPage />
                </Dialogue>
            )}
        </div>
    );
};

export default Navbar;
